import type { WorkflowStage } from '@/components/ApprovalStageWizard/types';

export const getTemplateStages = (templateName: string): WorkflowStage[] => {
  const timestamp = Date.now();
  
  switch (templateName) {
    case 'Single Manager':
      return [
        {
          id: `stage-${timestamp}-0`,
          name: 'Manager Review',
          description: 'Direct manager reviews and approves timesheet',
          order: 1,
          status: 'configured',
          stageData: {
            basicDetails: {
              stageName: 'Manager Review',
              description: 'Direct manager reviews and approves timesheet',
            },
            approver: {
              approverType: 'role',
              roleType: 'DirectManager',
              cannotApproveOwn: true,
            },
            smartRules: {
              rules: [],
              onApproved: {
                type: 'continue',
              },
              onRejected: {
                type: 'reject',
              },
            },
            notifications: {
              onApproved: [],
              onRejected: [],
            },
          },
          ruleCount: {
            preApproval: 0,
            postApproval: 0,
          },
        },
      ];
    
    case 'Two-Stage':
      return [
        {
          id: `stage-${timestamp}-0`,
          name: 'Manager Review',
          description: 'Direct manager reviews timesheet',
          order: 1,
          status: 'configured',
          stageData: {
            basicDetails: {
              stageName: 'Manager Review',
              description: 'Direct manager reviews timesheet',
            },
            approver: {
              approverType: 'role',
              roleType: 'DirectManager',
              cannotApproveOwn: true,
            },
            smartRules: {
              rules: [],
              onApproved: {
                type: 'continue',
              },
              onRejected: {
                type: 'reject',
              },
            },
            notifications: {
              onApproved: [],
              onRejected: [],
            },
          },
          ruleCount: {
            preApproval: 0,
            postApproval: 0,
          },
        },
        {
          id: `stage-${timestamp}-1`,
          name: 'Department Head Approval',
          description: 'Department head provides final approval',
          order: 2,
          status: 'configured',
          stageData: {
            basicDetails: {
              stageName: 'Department Head Approval',
              description: 'Department head provides final approval',
            },
            approver: {
              approverType: 'role',
              roleType: 'DepartmentHead',
              cannotApproveOwn: true,
            },
            smartRules: {
              rules: [],
              onApproved: {
                type: 'gotoEnd',
              },
              onRejected: {
                type: 'reject',
              },
            },
            notifications: {
              onApproved: [],
              onRejected: [],
            },
          },
          ruleCount: {
            preApproval: 0,
            postApproval: 0,
          },
        },
      ];
    
    case 'Auto-Approve':
      return []; // No stages for auto-approve
    
    default:
      return [];
  }
};
